angular.module('unica_hotel.hotel_services')

.factory('HotelEditService', function ($http, getBaseApiURL) {

	var hotelEditService = {};

	hotelEditService.update = function (hotelData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/hotel/update/' + hotelData.id,
			data: hotelData
		}).then(function(result) {

			if ( result ) {
				return result.data.hotel;
			}

		});

	};

	return hotelEditService;
});